import React from "react";

const Card = ({id, name, email}) => {
    return (
        <div className='tc bg-light-purple  dib br3 pa3 ma3 grow bw2 shadow-5'>
            <img alt='robots' src={`https://robohash.org/${id}`} />
            <div>
                <h2>{name}</h2>
                <p>{email}</p>
            </div>
        </div>
    
    );
}

export default Card;